module.exports = __webpack_public_path__ + "img/viewfdbck.eea7445d.svg";